document.addEventListener('DOMContentLoaded', function () {
  const DELIVERY_VARIANT_ID = 42547841695792;
  let VALID_PINCODES = [];

  // === LOAD PINCODES FROM JSON FILE ===
  async function loadPincodes() {
    try {
      const res = await fetch(window.ALLOWED_PINCODES_URL);
      const data = await res.json();
      VALID_PINCODES = data.pincodes || [];
      console.log('✅ Loaded Pincodes:', VALID_PINCODES);
    } catch (err) {
      console.error('❌ Failed to load pincodes:', err);
    }
  }

  // === CART HELPERS ===
  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function refreshCartDrawer() {
    try {
      const htmlRes = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
      const html = await htmlRes.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer, .cart-drawer');
      const drawer = document.querySelector('cart-drawer, .cart-drawer');
      if (drawer && newDrawer) drawer.innerHTML = newDrawer.innerHTML;

      setupPincodeVerifier();
      await refreshVerifierVisibility();
      await hideDeliveryControls();
      await syncInstallationWithProducts();
    } catch (e) {
      console.error('Error refreshing cart drawer:', e);
    }
  }

  // === PINCODE VERIFIER LOGIC ===
  function setupPincodeVerifier() {
    const verifier = document.querySelector('#pincode-verifier');
    if (!verifier) return;

    const input = verifier.querySelector('#pincode-input');
    const checkBtn = verifier.querySelector('#pincode-check');
    const deliveryOptions = verifier.querySelector('#delivery-options');
    const oneDayBtn = verifier.querySelector('#one-day-btn');

    // Check pincode
    checkBtn.onclick = async (e) => {
      e.preventDefault();
      const pin = input.value.trim();

      if (VALID_PINCODES.includes(pin)) {
        deliveryOptions.style.display = 'block';
        input.disabled = true;
        input.style.backgroundColor = '#f0f0f0';
        input.style.cursor = 'not-allowed';
        checkBtn.disabled = true;
        checkBtn.style.opacity = '0.5';
        checkBtn.style.cursor = 'not-allowed';
        await savePincodeToCart(pin);
      } else {
        alert('Sorry, installation is not available for this pincode.');
      }
    };

    // Add installation product
    if (oneDayBtn) {
      oneDayBtn.onclick = async (e) => {
        e.preventDefault();
        oneDayBtn.disabled = true;
        oneDayBtn.textContent = 'Adding...';
        try {
          const cart = await getCart();
          const totalProducts = cart.items
            .filter(i => i.variant_id != DELIVERY_VARIANT_ID)
            .reduce((sum, item) => sum + item.quantity, 0);

          const deliveryItem = cart.items.find(i => i.variant_id == DELIVERY_VARIANT_ID);

          if (totalProducts > 0) {
            if (!deliveryItem) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: DELIVERY_VARIANT_ID, quantity: totalProducts })
              });
            } else if (deliveryItem.quantity !== totalProducts) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: deliveryItem.key, quantity: totalProducts })
              });
            }
          }
          await refreshCartDrawer();
        } catch (err) {
          console.error('Error adding installation:', err);
        } finally {
          oneDayBtn.disabled = false;
          oneDayBtn.textContent = 'Installation charges Rs.1500 per Product';
        }
      };
    }
  }

  function savePincodeToCart(pincode) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Pincode': pincode } })
    });
  }

  // === SHOW/HIDE VERIFIER ===
  async function refreshVerifierVisibility() {
    const cart = await getCart();
    const hasDelivery = cart.items.some(i => i.variant_id == DELIVERY_VARIANT_ID);
    const hasProducts = cart.items.some(i => i.variant_id != DELIVERY_VARIANT_ID);
    const verifier = document.querySelector('#pincode-verifier');
    if (verifier) {
      verifier.style.display = (hasDelivery || !hasProducts) ? 'none' : 'block';
    }
  }

  // === HIDE ONLY QTY (+ / - / number) FOR INSTALLATION ITEM — KEEP DELETE BUTTON ===
  async function hideDeliveryControls() {
    const cart = await getCart();
    const deliveryItem = cart.items.find(i => i.variant_id == DELIVERY_VARIANT_ID);
    if (!deliveryItem) return;

    document.querySelectorAll('.cart-item').forEach(item => {
      const title = item.querySelector('.cart-item__name, .cart-item__title a');
      if (title && title.textContent.trim().includes(deliveryItem.title)) {
        const qtyWrapper = item.querySelector('.quantity-popover-container');
        if (qtyWrapper) qtyWrapper.style.display = 'none';

        const removeBtn = item.querySelector('cart-remove-button');
        if (removeBtn) {
          removeBtn.style.display = 'block';
          removeBtn.style.visibility = 'visible';
          removeBtn.style.opacity = '1';
          removeBtn.removeAttribute('disabled');
        }

        if (title.tagName.toLowerCase() === 'a') {
          title.removeAttribute('href');
          title.style.pointerEvents = 'none';
          title.style.color = 'inherit';
        }
      }
    });
  }

  // === SYNC INSTALLATION COUNT + REFRESH PAGE IF EMPTY ===
  async function syncInstallationWithProducts() {
    const cart = await getCart();

    if (cart.items.length === 0) {
      window.location.reload();
      return;
    }

    const totalProducts = cart.items
      .filter(i => i.variant_id != DELIVERY_VARIANT_ID)
      .reduce((sum, item) => sum + item.quantity, 0);
    const deliveryItem = cart.items.find(i => i.variant_id == DELIVERY_VARIANT_ID);

    if (deliveryItem && totalProducts !== deliveryItem.quantity) {
      if (totalProducts === 0) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: deliveryItem.key, quantity: 0 })
        });
      } else {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: deliveryItem.key, quantity: totalProducts })
        });
      }
      await refreshCartDrawer();
    }
  }

  // === AUTO REFRESH ON QUANTITY CHANGE OR REMOVE ===
  document.addEventListener('click', async (e) => {
    const target = e.target.closest('.cart-remove-button, .cart-item__remove, .quantity__button');
    if (!target) return;
    setTimeout(async () => {
      const cart = await getCart();
      if (cart.items.length === 0) window.location.reload();
      else await refreshCartDrawer();
    }, 500);
  });

  // === SHOPIFY CART EVENT LISTENER ===
  document.addEventListener('cart:updated', () => {
    setTimeout(async () => {
      const cart = await getCart();
      if (cart.items.length === 0) window.location.reload();
      else await refreshCartDrawer();
    }, 500);
  });

  // === OBSERVER FOR DYNAMIC DRAWER ===
  const drawer = document.querySelector('cart-drawer, .cart-drawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      setupPincodeVerifier();
      refreshVerifierVisibility();
      hideDeliveryControls();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // === INITIALIZE ===
  loadPincodes().then(() => {
    setupPincodeVerifier();
    refreshVerifierVisibility();
  });

  // === REMOVE "increments of" ALERT ===
  const alertObserver = new MutationObserver(() => {
    document.querySelectorAll('[role="alert"]').forEach(el => {
      if (el.textContent.includes('increments of')) el.remove();
    });
  });
  alertObserver.observe(document.body, { childList: true, subtree: true });
});
